<div [ngClass]="position" class="dropdown-menu" [class.visible]="isVisible">
  <div class="dropdown-scroll-container">
    <ng-content></ng-content>
  </div>
</div>
